// Returns the header highlight banner for the requested placement,
// or no banner when none should be shown.
export const BannerService_GetBannerLazy = () =>
  import("./service.grpc").then((m) => m.BannerService_GetBanner);
BannerService_GetBannerLazy.method =
  "aysa_api.services.banner.BannerService/GetBanner" as const;
